import PContentComponent from '@/domain/Content/components/PContent.vue'
import { contentRoutes as routes } from '@/domain/Content/contentRoutes'
import { CContentRouteNames as routeNames } from '@/domain/Content/contracts/CContentRouteNames'

export const PContent = PContentComponent

export const contentRoutes = routes

export const CContentRouteNames = routeNames
